module.exports = __webpack_public_path__ + "img/houseType1.1c2ec344.jpg";